import PropTypes from 'prop-types';
import * as yup from 'yup';
import {connect} from 'formik';

import {
    createContactSchemaFromPersonDataConfig,
    createPCOPersonDataSchemaFromPersonDataConfig
} from '../../speaker/PersonDataForm';
import Speaker from '../../speaker/Speaker';

/**
 * Widget für die Darstellung des Speakers/der Speaker für diese Einreichung
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function SpeakerWidget(props) {
    return <Speaker
        description={props.widget.description}
        toggleLabel={props.widget.alternativeSpeakerConfig.toggleLabel}
        speaker={props.widget.alternativeSpeakerConfig.personDataConfig}
        submitter={props.widget.changeSubmitterDataConfig.personDataConfig}
        changeSubmitterDataEnabled={props.widget.changeSubmitterDataConfig.enabled}
        alternativeSpeakerEnabled={props.widget.alternativeSpeakerConfig.enabled}
        formik={props.formik}
        widgetId={props.widget.id}
        dataTestId={props.widget.id}
    />
}

function isAltSpeaker(submission) {
    if (submission.speaker && submission.submittedBy) {
        return submission.speaker.id !== submission.submittedBy.id
    }
    return false;
}

SpeakerWidget.propTypes = {
    widget: PropTypes.object,
    formik: PropTypes.object
};

export function type() {
    return 'speaker';
}

export function initialValue(widget) {
    return {
        speaker: {
            mainContact: {
                salutation: '',
                title: '',
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                company: '',
                function: '',
                street: '',
                houseno: '',
                postalCode: '',
                city: '',
                countryISOCode: ''
            },
            pcoPersonData: {
                homepageUrl: '',
                vita: '',
                image: {
                },
                photographer: '',
                imageCaption: ''
            }
        },
        submitter: {
            mainContact: {
                salutation: '',
                title: '',
                phone: '',
                company: '',
                function: '',
                street: '',
                houseno: '',
                postalCode: '',
                city: '',
                countryISOCode: ''
            },
            pcoPersonData: {
                homepageUrl: '',
                vita: '',
                image: {
                },
                photographer: '',
                imageCaption: ''
            }
        },
        altSpeaker: false
    }
}

/**
 * @param widget
 * @param allowPartialSubmissions
 * @returns {ObjectSchema<Shape<object | undefined, {speaker: {mainContact: {} | undefined} | undefined, altSpeaker: boolean | undefined, submitter: {mainContact: {} | null | undefined} | undefined}>, object>}
 */
export function schema(widget, allowPartialSubmissions) {
    // Nur wenn ein alternativer Referent angegeben werden soll sind die Felder für diese zu validieren,
    // da sonst das Formular nie gültig werden kann.

    const speakerSchemaFromPersonDataConfig = createContactSchemaFromPersonDataConfig(widget.alternativeSpeakerConfig.personDataConfig);
    const submitterSchemaFromPersonDataConfig = createContactSchemaFromPersonDataConfig(widget.changeSubmitterDataConfig.personDataConfig);

    return yup.object().shape({
        speaker: yup.object().shape({
            mainContact: yup.object().shape(speakerSchemaFromPersonDataConfig),
            pcoPersonData: yup.object().shape(createPCOPersonDataSchemaFromPersonDataConfig(widget.alternativeSpeakerConfig.personDataConfig))
        }).when('altSpeaker', (altSpeaker, schema) => {
            return altSpeaker
                ? schema
                : yup.mixed().nullable()
        }),
        submitter: yup.object().shape({
            mainContact: widget.changeSubmitterDataConfig.enabled
                ? yup.object().shape(submitterSchemaFromPersonDataConfig)
                : yup.mixed().nullable(),
            pcoPersonData: widget.changeSubmitterDataConfig.enabled
                ? yup.object().shape(createPCOPersonDataSchemaFromPersonDataConfig(widget.changeSubmitterDataConfig.personDataConfig))
                : yup.mixed().nullable()
        }),
        altSpeaker: yup.boolean()
    });
}

/**
 * liest den Wert aus der Paper Submission aus und gibt ihn zurück
 * Das wird benötigt, um die Form zu initialisieren
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {*}
 */
export function submissionValue(callForPapers, widget, submission) {
    return {
        speaker: submission.speaker,
        submitter: submission.submittedBy,
        altSpeaker: isAltSpeaker(submission)
    };
}

const FormikConnectedSpeakerWidget = connect(SpeakerWidget);

export function component() {
    return FormikConnectedSpeakerWidget;
}
